import {tagTypeAction} from './constants';

export default (tagsList) => {
	let newCustomTagsList = [...tagsList]
		.filter((t) => t.isCustom === true)
		.map((tag) => {
			return {
				colorCode: tag.color,
				id: tag.id,
				name: tag.name,
				isCustom: tag.isCustom,
				isDisabled: false,
				action: tagTypeAction.existing
			};
		});
	return newCustomTagsList.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
};
